module.exports = __webpack_public_path__ + "img/DS40_6x9v2.86730af8.png";